import { requestGet as wsRequestGet, requestPost as wsRequestPost } from './_wsApiFetchData';
import determineFieldType from '../common/determineFieldType';

export async function searchUsers(options, language, timeZone, cancelToken) {
  const { key, resultsCount, skipPages } = options;
  const params = {
    page: skipPages,
    count: resultsCount
  }
  
  return toPascal(await wsRequestGet(`/admin/users/search/${decodeURIComponent(key == undefined ? '' : key)}`, language, timeZone, params, cancelToken));
}

export async function getUser(id, language, timeZone, cancelToken) {
  let user = toPascal(await wsRequestGet(`/admin/users/details/${id}`, language, timeZone, null, cancelToken));
  let wallet = await wsRequestPost('/admin/Users/Wallet/Get', language, timeZone, {
    UserId: id
  }, {}, cancelToken);
  user.Wallet = wallet;

  return user;
}

// Wallet balance changes, newest first: admin adjustments, credit used by purchases and
// credit given back by refunds. Recorded only from 27 Oct 2026, so older wallets start empty.
export async function getWalletHistory(userId, page, count, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet('/admin/Users/Wallet/History', language, timeZone, {
    userId,
    page: page || 1,
    count: count || 50
  }, cancelToken));
}

export async function lookupByEmailOrId(key, language, timeZone, cancelToken) {
  if (!key) {
    return [];
  }

  const fieldName = await determineFieldType(key);
  const supportedFields = ['Id', 'Email'];

  if (supportedFields.indexOf(fieldName) < 0) {
    return [];
  }

  if (fieldName === 'Id') {
    const { Id, Name, Email } = await getUser(key, language, timeZone, cancelToken);

    return [{
      label: `${Email} - ${Name}`,
      value: Id
    }];
  } if (fieldName === 'Email') {
    const options = {
      resultsCount: 5,
      key
    };

    const results = await searchUsers(options, language, timeZone, cancelToken);

    return results.map(({ Id, Name, Email }) => ({
      label: `${Email} - ${Name}`,
      value: Id
    }));
  }
}

export async function changeEmail(email, userId, language, timeZone, cancelToken) {
  return wsRequestPost(
    '/admin/Profile/ChangeEmail', 
    language, 
    timeZone, {
      Id: userId,
      NewEmail: email
    }, {
      Id: userId,
      NewEmail: email
    }, 
    cancelToken);
}

export async function generatePassword(userId, language, timeZone) {
  const { password } = await wsRequestPost('/admin/profile/GeneratePassword', language, timeZone, {}, { userGuid: userId }, null);
  return password;
}

export async function forgetUser(userId, language, timeZone) {
  return wsRequestGet(`/admin/users/forget/${userId}`, language, timeZone, {}, null);
}

export async function markEmailVerified(userId, language, timeZone) {
  return wsRequestPost(`/admin/users/${userId}/mark-email-verified`, language, timeZone, {}, null);
}

// Verification state, live SendGrid suppression entries and recent tracked
// verification/login-code delivery events for the user's address.
export async function getEmailDelivery(userId, language, timeZone, cancelToken) {
  return wsRequestGet(`/admin/users/${userId}/email-delivery`, language, timeZone, {}, cancelToken);
}

export async function clearEmailSuppressions(userId, language, timeZone) {
  return wsRequestPost(`/admin/users/${userId}/clear-email-suppressions`, language, timeZone, {}, null);
}

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}
